/* eslint-disable */
export default {
  forward: '轉接',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
